<template>
  <section id="formulario" class="bg-transparent h-screen py-12 pb-64">
    
    <div class="py-60 flex flex-col items-center justify-center">
      <h2 class="text-6xl text-white mt-16 font-bold">Acreditación finalizada</h2>
      <h2 class="text-6xl text-white mt-4 font-bold">Lo esperamos en próximas ediciones</h2>
    </div>

  </section>
</template>
  
